import React from 'react'
import ProductionCompInjectionMouldingSetting from "./productionCompInjectionMouldingSetting"
import ProductionCompExtrutionSetting from './productionCompExtrutionSetting';
import ProductionCompPunchPressSetting from './ProductionCompPunchPressSetting';
import ProductionCompCNCSetting from "./productionCompCNCSetting"

const ProductionCompSetting = ({ form,
  filter,
  minTime,
  maxTime,
  initialValues,config }) => {
  const { templateType } = filter;
  switch (templateType) {
    case 1:
      return (
        <ProductionCompInjectionMouldingSetting
          minTime={minTime}
          maxTime={maxTime}
          form={form}
          filter={filter}
          initialValues={initialValues}
          config={config} />
      )
    case 2:
      return(
        <ProductionCompExtrutionSetting
           minTime={minTime}
          maxTime={maxTime}
          form={form}
          filter={filter}
          initialValues={initialValues}
          config={config}/>
      )
    case 3:
      return(
        <ProductionCompPunchPressSetting
        minTime={minTime}
        maxTime={maxTime}
        form={form}
        filter={filter}
        initialValues={initialValues}
        config={config}/>
      )
      case 4:
        return(
          <ProductionCompCNCSetting
          minTime={minTime}
          maxTime={maxTime}
          form={form}
          filter={filter}
          initialValues={initialValues}
          config={config}/>
        )
  }
}

export default ProductionCompSetting